import http from '@/plugins/axios/index';
const state = {
  files: [
    // {
    //   cover: '2020-8-13/d73b2de0-dd0b-11ea-8cef-ef4fc398641d.png',
    //   url: '2020-9-14/1521cf36-3b77-49d7-87aa-01871a0446bf.mp4',
    //   name: 'aaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaa.mp4'
    // }
  ],
  inputFile: {},
  inputInfo: {}
};

const getters = {
  getCompletedFiles: (state) => state.files,
  getInputFile: (state) => state.inputFile,
  getInputInfo: (state) => state.inputInfo
};

const mutations = {
  setFiles(state, files) {
    state.files = files;
  },
  clearFiles(state) {
    state.files = [];
  },
  addFile(state, file) {
    state.files.push(file);
  },
  deleteFile(state, file) {
    let index = state.files.indexOf(file);
    if (index > -1) {
      state.files.splice(index, 1);
    }
  },
  setInputFile(state, file) {
    state.inputFile = file;
  },
  setInputInfo(state, info) {
    state.inputInfo = info;
  }
};

const actions = {
  async process({ state }, { speed, nonwatermark }) {
    const resp = await http.post('/onlineTask', {
      type: 6,
      key: state.inputInfo.filename,
      speed,
      nonwatermark
    });
    if (resp && resp.data && resp.data.code === 200) {
      let data = resp.data.data;
      return data;
    }
    return false;
  },
  async checkStatus(x, { taskId = '' } = {}) {
    x;
    let result = await http.get(`/onlineTask/getProgress?taskId=${taskId}`);
    if (result.data.code === 200) {
      return result.data.data;
    }
    return false;
  }
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
};
